import {DertigenEvent} from "../model/DertigenEvent";

export const buildFriendHelpMove = (amount: number): DertigenEvent => ({
    gulps: amount,
    turnMove: false,
});
